import React from 'react';

import {
    BodyText,
    Callout,
    CommentsIllustration,
    Heading,
    UtilityInfoIcon,
} from '@placer-ui/components';
import { useGetTagsQuery } from 'hooks/queries/tags/use-get-tags-query';
import type { SupportRequestsSuccessModalProps } from 'features/offline-reports/support-requests/components/support-requests-modals/modals/support-success-modal/types';

import styles from './support-success-modal.module.scss';
import { getFeatureFlags } from 'core/flow-control';

const defaultMessages = [
    <>A support ticket has been opened.</>,
    <>One of our team members will reach out to you shortly.</>,
];

const LARGE_REQUEST_MESSAGE =
    "You've submitted a large request. Your CSM may be notified for approval.";
const LARGE_REQUEST_COUNT = 200;

export const SupportRequestsSuccessContent = ({
    title = 'We’ve Received Your Request!',
    deliveryETA,
    propertiesCount,
    messages = defaultMessages,
    tagId,
}: SupportRequestsSuccessModalProps) => {
    const { data: tags } = useGetTagsQuery();
    const { enable_new_message_properties_request_ff } = getFeatureFlags();

    const tagName = tags?.personalTags.find((tag) => tag.id === tagId)?.name;

    return (
        <div className={styles.successContent}>
            <div className={styles.successIcon}>
                <CommentsIllustration />
            </div>
            <Heading variant="h2">{title}</Heading>

            {deliveryETA && <div>{deliveryETA}</div>}

            {enable_new_message_properties_request_ff &&
                propertiesCount &&
                propertiesCount >= LARGE_REQUEST_COUNT &&
                LARGE_REQUEST_MESSAGE}

            <div className={styles.successTextWrapper}>
                {messages.map((message, index) => (
                    <BodyText key={index}>{message}</BodyText>
                ))}
            </div>

            {tagName && (
                <div className={styles.callout}>
                    <Callout
                        FreeTextIcon={<UtilityInfoIcon />}
                        text={`All newly added properties will be automatically included in your tag ${tagName}.`}
                        isCondensed
                    />
                </div>
            )}
        </div>
    );
};
